import { styled } from "@uhg-abyss/web/tools/styled";
import { Button } from "@uhg-abyss/web/ui/Button";

const ExpandRowContainer = styled("div", {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "16px 0",
  width: "100%",
});

interface ExpandProvidersRowProps {
  label: string;
  onClick: () => void;
}

export const ExpandProvidersRow = ({ label, onClick }: ExpandProvidersRowProps) => {
  return (
    <ExpandRowContainer>
      <Button
        data-testid="test-id-provider-list-expand-providers-button"
        id="obc-find-provider-expand-providers-btn"
        data-id="obc-find-provider-expand-providers-btn"
        data-obc-label="Expand Providers Button"
        variant="outline"
        onClick={onClick}
      >
        {label}
      </Button>
    </ExpandRowContainer>
  );
};
